import { Box, useTheme } from "@mui/material";
import Text from "../../../theme/text/Text";
import Shbutton from "../../../theme/buttons/Shbutton";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
// import ArrowLeftAltIcon from '@mui/icons-material/ArrowLeftAltIcon';
import { tokens } from "../../../../theme";
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { useCallback, useEffect, useMemo, useState } from "react";

import SidepanelHeaderActiongroup from "../../../theme/sidepanel2/SidepanelHeaderActiongroup";
import Pickup from "./Views/Pickup";

import Sidepanel2 from "../../../theme/sidepanel2/Sidepanel2";
import { useTranslation } from 'react-i18next';
import Details from "./Views/Details";
import Authorisation from "./Views/Authorisation";
import Costs from "./Views/Costs";
import FuelSurcharge from "./Views/FuelSurcharge";
import Surcharges from "./Views/Surcharges";
import { ReactComponent as DhlLogo } from '../../../../styles/svg/dhl.svg';
import { ReactComponent as DhlGermanyLogo } from '../../../../styles/svg/dhlgermany.svg';
import { ReactComponent as DpdLogo } from '../../../../styles/svg/dpd.svg';
import { ReactComponent as PostNLLogo } from '../../../../styles/svg/postnl.svg';
import { ReactComponent as BolLogo } from '../../../../styles/svg/bol.svg';
import { ReactComponent as IntrapostLogo } from '../../../../styles/svg/intrapost.svg';
import { ReactComponent as CirroLogo } from '../../../../styles/svg/cirro.svg';
import { ReactComponent as SendcloudLogo } from '../../../../styles/svg/sendcloud.svg';
import { ReactComponent as UpsLogo } from '../../../../styles/svg/ups.svg';
import { ReactComponent as InnosendLogo } from '../../../../styles/svg/innosend.svg';
import { ReactComponent as MyparcelLogo } from '../../../../styles/svg/myparcel.svg';
import { ReactComponent as GlsLogo } from '../../../../styles/svg/gls.svg';
import { ReactComponent as TrunkrsLogo } from '../../../../styles/svg/trunkrs.svg';
import { ReactComponent as CycloonLogo } from '../../../../styles/svg/cycloon.svg';
import { ReactComponent as HstLogo } from '../../../../styles/svg/hst.svg';
import { ReactComponent as MyparcelcomLogo } from '../../../../styles/svg/myparcelcom.svg';
import { ReactComponent as AmpereLogo } from '../../../../styles/svg/ampere.svg';
import { ReactComponent as ZinepsLogo } from '../../../../styles/svg/zineps.svg';
import { ReactComponent as WegrowLogo } from '../../../../styles/svg/wegrow.svg';
import { spShipperDetailsConfig } from "./spShipperDetailsConfig";
import ShRowSkeleton from "../../../theme/skeleton/ShRowSkeleton";
import { useGetShipperQuery } from "../../../../newapi/shipper/shipperSlice";
import { useGetSettingsQuery } from "../../../../newapi/global/generalApiSlice";
import ReturnCosts from "./Views/ReturnCosts";
import CheckoutSettings from "./Views/CheckoutSettings";
import { shipperSupportsCheckout } from "../../../../utils/shipperValidation";

const SidePanelActions = (props) => {    
    return (
        <SidepanelHeaderActiongroup>
            <Shbutton isCancel={true} 
                onClick={() => props.setIsExtended(false)} 
                color="primary" 
                variant="text" 
                startIcon={<ArrowRightAltIcon/>}
            >
                Cancel
            </Shbutton>

        </SidepanelHeaderActiongroup>
    )
}

const SpShipperDetails = (props) => {
    const { t, ready, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { data: shipperData, isLoading,isFetching,isError } = useGetShipperQuery(props.shipperId,
    {
        skip: !props.shipperId
    });

    const { data: shippingSettings } = useGetSettingsQuery("shipping");
    const shippingOptionsEnabled = shippingSettings?.find(s => s.key === "shipping_options_enabled")?.value === "true";

    const config = useMemo(() => {
        // The seeded Pickup shipper opens from the general settings with only its checkout settings
        if (props.checkoutOnly) {
            return { checkoutSettings: spShipperDetailsConfig.checkoutSettings };
        }
        if (shippingOptionsEnabled && shipperSupportsCheckout(shipperData?.type)) {
            return spShipperDetailsConfig;
        }
        // Exclude checkoutSettings tab when the global setting is off or the shipper type has no checkout support
        const { checkoutSettings, ...rest } = spShipperDetailsConfig;
        return rest;
    }, [props.checkoutOnly, shippingOptionsEnabled, shipperData?.type]);

    const defaultIcon = useMemo(() => ({
        theme: theme.palette.mode === "dark" ? "blue" : "primary",
        content: <LocalShippingOutlinedIcon/>
    }), [theme.palette.mode]);

    // const defaultOptions = useMemo(() => [
    //     { component: <ShRowSkeleton heading={t("order")} /> },
    //     { component: <ShRowSkeleton heading={t("reference")} /> },
    //     { component: <ShRowSkeleton heading={t("name")} /> },
    //     { component: <ShRowSkeleton heading={t("phone")} /> },
    //     { component: <ShRowSkeleton heading={t("email")} /> },
    //     { component: <ShRowSkeleton heading={t("relation")} /> },
    //     { component: <HeaderDateBox skeleton t={i18n}/> },
    //     { component: <ShRowSkeleton heading={t("warehouse")} /> },
    //     { component: <ShRowSkeleton heading={t("sku_amount")} /> },
    //     { component: <ShRowSkeleton heading={t("items")} /> },
    // ], [t]);
    
    const setIsExtendedCallback = useCallback(() => props.setIsExtended(false), [props.setIsExtended]);

    // Memoize the default state to avoid recalculating it on every render
    const defaultState = useMemo(() => ({
        title: "",
        subTitle: "",
        // options: defaultOptions,
        icon: defaultIcon,
        actions:<SidePanelActions setIsExtended={setIsExtendedCallback} />   
    }), [defaultIcon,/*defaultOptions,*/ setIsExtendedCallback]);

    const [panel, setPanel] = useState(defaultState);

    useEffect(() => {
        setPanel(defaultState);
    }, [isFetching,props.shipperId,theme.palette.mode])
    
    useEffect(() => {
        if (!isLoading && !isFetching && shipperData) {
            let shipperLogo;
            let color;
            let myTheme;
            switch (shipperData.type) {
                case 'dhl':
                    color="#FFFCF2";
                    color="rgba(255,203,1,.10)";
                    shipperLogo = <DhlLogo />;
                    break;
                case 'postnl':
                    color="#FFF8F2";
                    color="rgba(245,105,0,.10)";
                    shipperLogo = <PostNLLogo />;
                    break;
                case 'dpd':
                    color="rgba(220,0,50,.10)";
                    shipperLogo = <DpdLogo/>;
                    break;
                case 'bol':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <BolLogo/>;
                    break;
                case 'intrapost':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <IntrapostLogo/>;
                    break;
                case 'cirro':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <CirroLogo/>;
                    break;
                case 'sendcloud':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <SendcloudLogo/>;
                    break;
                case 'ups':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <UpsLogo/>;
                    break;
                case 'innosend':
                case 'innosendv2':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <InnosendLogo/>;
                    break;
                case 'myparcel':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <MyparcelLogo/>;
                    break;
                case 'gls':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <GlsLogo/>;
                    break;
                case 'trunkrs':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <TrunkrsLogo/>;
                    break;
                case 'cycloon':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <CycloonLogo/>;
                    break;
                case 'hst':
                    color="#F2F2FA";
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <HstLogo/>;
                    break;
                case 'myparcelcom':
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <MyparcelcomLogo/>;
                    break;
                case 'ampere':
                    color="rgba(0,0,153,.10)";
                    shipperLogo = <AmpereLogo/>;
                    break;
                case 'dhlgermany':
                    color="rgba(255,203,1,.10)";
                    shipperLogo = <DhlGermanyLogo/>;
                    break;
                case 'zineps':
                    color="rgba(114,200,185,.10)";
                    shipperLogo = <ZinepsLogo/>;
                    break;
                case 'wegrow':
                    color="rgba(33,195,200,.10)";
                    shipperLogo = <WegrowLogo/>;
                    break;
                default:
                    myTheme = theme.palette.mode === "dark" ? "blue" : "primary";
                    shipperLogo = <LocalShippingOutlinedIcon/>
                    break;
            }
        
            setPanel((prevPanel) => ({
                ...prevPanel,
                title: shipperData.name,
                subTitle: shipperData.reference ?? "",
                icon: {
                    ...(color ? { color: color } : { theme: myTheme }), // Conditionally add color or theme
                    content: shipperLogo
                },
                options: [
                    // {
                    //     heading: t('zone'),
                    //     content: data.warehouseZone?.description
                    // },
                    // {
                    //     component: <MultiProductBox 
                    //     multiproduct={data.multiproduct} 
                    //     multiproductzone={data.warehouseZone.multiproduct} 
                    //     multibatchzone={data.warehouseZone.multibatch}/>
                    // },
                    // {
                    //     heading: t('location_type'),
                    //     content: data.warehouseLocationType?.description
                    // },
                    // {
                    //     heading: t('reach_type'),
                    //     content: data.reachType?.description
                    // }
                ],
            }));
        }
    }, [shipperData, isLoading, isFetching,t,theme.palette.mode]);


    return (
        <Sidepanel2
            skeleton={isLoading || isFetching}
            tabConfig={config}
            content={panel} 
            isExtended={props.isExtended} 
            setIsExtended={props.setIsExtended}>
                {props.checkoutOnly ? (
                    <CheckoutSettings config={config.checkoutSettings} data={shipperData} />
                ) : (
                <>
                    <Details config={config.details} data={shipperData} setIsExtended={props.setIsExtended}/>
                    <Pickup config={config.pickup} data={shipperData}/>
                    <Authorisation config={config.authorisation} data={shipperData} />
                    <Costs config={config.costs} shipperId={props.shipperId} />
                    <ReturnCosts config={config.returnCosts} shipperId={props.shipperId} />
                    <FuelSurcharge config={config.fuelSurcharge} shipperId={props.shipperId} />
                    <Surcharges config={config.surcharges} shipperId={props.shipperId} />
                    {config.checkoutSettings && (
                        <CheckoutSettings config={config.checkoutSettings} data={shipperData} />
                    )}
                    {/* { <Barcodes id={props.data ? props.data.id : -1} apiRef={barcodesApiRef}/> } */}
                    {/* { <Channels id={props.data ? props.data.id : -1} apiRef={channelsApiRef}/> } */}
                    {/* { <Logs id={props.data ? props.data.id : -1} apiRef={logsApiRef}/> } */}
                </>
                )}
        </Sidepanel2>
    );
};

export default SpShipperDetails;